import { Component, input, InputSignal } from '@angular/core';

import { TableComponent } from './table/table.component';
import { DiseaseDashboardWidgetTableHeaderComponent } from './table-header.component';
import { DiseaseDashboardWidgetTableRowComponent } from './table-row.component';
import { CropFieldAdvice } from '../disease-overview-table.component/models/models';

@Component({
  selector: 'app-disease-dashboard-widget-table',
  styleUrl: './widget.component.scss',
  template: `
    <app-disease-dashboard-widget-table-header
      [selectedDates]="selectedDates()"
      [translationPrefix]="translationPrefixValue"
      />
      @for (advice of advices(); track trackByAdvice($index, advice); let last = $last) {
        <app-disease-dashboard-widget-table-row
          class="table-row"
          [isLastRow]="last"
          [advice]="advice"
          [selectedDates]="selectedDates()"
          [translationPrefix]="translationPrefixValue"
          (selectionChange)="onRowSelectionChange($event, advice)"
          />
      }
    `,
  imports: [DiseaseDashboardWidgetTableHeaderComponent, DiseaseDashboardWidgetTableRowComponent],
})
export class DiseaseDashboardWidgetTableComponent extends TableComponent {
  public readonly selectedDates: InputSignal<Date[]> = input.required<Date[]>();
  public readonly translationPrefix: InputSignal<string> = input<string>('blightV2');

  protected get translationPrefixValue(): string {
    return this.translationPrefix();
  }

  protected trackByAdvice(_: number, advice: CropFieldAdvice): CropFieldAdvice {
    return advice;
  }
}
